import {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Icon, Table} from 'semantic-ui-react';
import {getTypeText as _} from '../../utils/homeworks';

function Homeworks(props) {
  const {course, doneHomeworks} = props;

  const homeworksCount = course.homeworks.length;
  const doneHomeworksCount = doneHomeworks.length;
  const hasRelatedCourse = props.reviewCount !== 0;

  return (
    <Table striped unstackable color={props.color} size='small'>
      <Table.Header>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan={hasRelatedCourse ? 4 : 3} textAlign='center'>
            <p>{props.name}</p>
            <p>{`انجام شده: ${doneHomeworksCount} از ${homeworksCount}`}</p>
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row textAlign='center'>
          <Table.HeaderCell content='درس'/>
          <Table.HeaderCell content='تکلیف'/>
          {hasRelatedCourse && (<Table.HeaderCell content='قبلی'/>)}
          <Table.HeaderCell content='وضعیت'/>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {course.homeworks.map(homework => (
          <Fragment key={homework.id}>
            <Table.Row>
              <Table.Cell textAlign='center'>
                {`${homework.lessonName} (${_(homework.type)})`}
              </Table.Cell>
              <Table.Cell textAlign='center'>{homework.name}</Table.Cell>
              {hasRelatedCourse && (
                <Table.Cell textAlign='center'>
                  {props.relatedStudentCourses.filter(
                    ({homeworks}) => homeworks.includes(homework.id)
                  ).map(({id}) => <Icon key={id} name='check square outline' size='large' color='green'/>)}
                </Table.Cell>
              )}
              <Table.Cell textAlign='center' className='p-0 m-0'>
                {doneHomeworks.includes(homework.id) ? (
                  <Icon name='check square outline' size='big' color='green'/>
                ) : (
                  <Icon name='square outline' size='big' color='yellow'/>
                )}
              </Table.Cell>
            </Table.Row>
          </Fragment>
        ))}
      </Table.Body>
    </Table>
  );
}

Homeworks.propTypes = {
  name: PropTypes.string.isRequired,
  course: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  reviewCount: PropTypes.number.isRequired,
  doneHomeworks: PropTypes.arrayOf(PropTypes.number).isRequired,
  relatedStudentCourses: PropTypes.arrayOf(PropTypes.object).isRequired
};

Homeworks.defaultProps = {reviewNum: 0};

export default Homeworks;
